export default __webpack_public_path__ + "static/media/neon_sign_board.32dc8940.svg";